import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Globle } from 'src/assets/globle';
import { SubServices } from './subservices.model';

@Injectable({
  providedIn: 'root'
})
export class SubservicesService {

  constructor(private http: HttpClient, private global: Globle) {

  }


  getAll(mainServiceId: number, status: boolean) {
    return this.http.get<SubServices[]>(this.global.APIURL + "subservice?mainServiceId=+" +
      mainServiceId + "&status=" + status);
  }

  getById(id: number) {
    return this.http.get<SubServices>(this.global.APIURL + "subservice/" + id);
  }

  Create(subservice: any) {
    return this.http.post(this.global.APIURL + "subservice", subservice)
  }

  Update(subservice: any) {
    return this.http.put(this.global.APIURL + "subservice", subservice)
  }

  upload(formdata: any) {
    return this.http.post<any>(this.global.APIURL + "subservice/upload", formdata)
  }

  Delete(id: number) {
    return this.http.delete(this.global.APIURL + "subservice/" + id)
  }
}
